import React from "react";
import "./FocusAreaApac.css";
import {
    createTheme,
    ThemeProvider,
    Box,
    Typography
} from '@mui/material';

const cardData = [
  {
    id: "malaysia",
    img: "/images/Home/Malaysia_card.png",
    title: "Malaysia",
    items: [
      "Google Cloud Certification",
      "ATAS (Accenture Technology Analyst School) Faculty Pool",
    ],
    style: { top: "61%", left: "18%", width: "468px" },
  },
  // {
  //   id: "thailand",
  //   img: "/images/Home/Thailand_card.png",
  //   title: "Thailand",
  //   items: ["Accenture Delivery Fundamentals CL0-12"],
  //   style: { top: "10%", left: "41%", width: "280px" },
  // },
  {
    id: "indonesia",
    img: "/images/Home/Indonesia_card.png",
    title: "Indonesia",
    items: [
      "Pega Certifications",
      "Temporal Training",
      "Consulting 101 Learning Path",
    ],
    style: { top: "57%", left: "60%", width: "383px" },
  },
  {
    id: "vietnam",
    img: "/images/new/South.png",
    title: "Vietnam",
    items: [
      "Leadership Development for mid management (ML7-8)",
      "Impactful Communication Skills",
      "Learning roadmap for new hires (Initial training, ATAS, Bootcamps, LHX)",
      "Platforms/Technologies (Upskilling, Cross Skilling, Certifications) "
    ],
    style: { top: "98%", left: "48%", width: "398px" },
  }
];

const localTheme = createTheme({
  typography: {
    fontFamily: 'Graphik-Regular',
  },
});

const FocusAreaApac = () => (
  <ThemeProvider theme={localTheme}>
    <Box className="focus-area-wrapper">
      <Box sx={{ width: "90%", margin: "auto", position: "relative" }}>
        <Typography variant="h4" color="primary" gutterBottom className="atc-header-apacfocusarea">
          Focus Area
        </Typography>
        <div className="header_focus_apac">
          <img src="images/Home/focusarea_line.png" alt="header_line" className="header_focus_line_img" />
        </div>
      </Box>

      <div className="map-stage-apac">
        <img src="/images/Home/APAC.png" alt="APAC Map" className="apac-map" />

        {cardData.map(({ id, img, title, items, style }) => (
          <div key={id} className="card_cluster" id={id} style={style}>
            <img className="card-bg" src={img} alt="card" />
            <div
              className={
                id === "indonesia"
                  ? "card-title-indonesia"
                  : id === "vietnam"
                    ? "card-title-vietnam"
                    : "card-title"
              }
            >
              {title}
            </div>

            <ul
              className={
                id === "indonesia"
                  ? "card-body-indonesia"
                  : id === "vietnam"
                    ? "card-body-vietnam"
                    : "card-body"
              }
            >
              {items.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Box>
  </ThemeProvider>
);

export default FocusAreaApac;
